import EventEmitter from 'events';
export default new EventEmitter();
export const HEADER_USER_FETCH = 'HEADER_USER_FETCH';